export default __webpack_public_path__ + "static/media/exata2.9fb51034.png";